export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  TIMEOUT: 30000,
  DEFAULT_HEADERS: {
    "Content-Type": "application/json",
  },
} as const;

export const ENDPOINTS = {
  GARE: {
    LIST: "/Competitions",
    GET_BY_ID: (id: number) => `/Competitions/${id}`,
    CREATE: "/Competitions",
    UPDATE: (id: number) => `/Competitions/${id}`,
    DELETE: (id: number) => `/Competitions/${id}`,
    ADD_CONCORRENTE: (garaId: number, concorrenteId: number) =>
      `/competitions/${garaId}/competitors/${concorrenteId}`,
    DELETE_CONCORRENTE: (garaId: number, concorrenteId: number) =>
      `/competitions/${garaId}/competitors/${concorrenteId}`,
    CREATE_GROUP: `/competitions/groups`,
    GET_GROUP: (competitionId: number) =>
      `/competitions/${competitionId}/groups`,
    DELETE_GROUP: (competitionId: number) =>
      `/competitions/${competitionId}/groups`,
  },
  CONCORRENTI: {
    LIST: "/Competitors",
    ALL: "/Competitors/All",
    GET_BY_ID: (id: number) => `/Competitors/${id}`,
    CREATE: "/Competitors",
    UPDATE: (id: number) => `/Competitors/${id}`,
    DELETE: (id: number) => `/Competitors/${id}`,
  },
  SETTORI: {
    LIST: "/Sections",
    GET_BY_ID: (id: number) => `/Sections/${id}`,
    CREATE: "/Sections",
  },
  RESULT: {
    SAVE_RANKING: (competitionId: number) =>
      `/results/competitions/${competitionId}/SaveRanking`,
    SAVE_GROUP_RANKING: (competitionId: number) =>
      `/results/competitions/${competitionId}/SaveGroupRanking`,
    GET_RANKING: (competitionId: number) =>
      `/results/competitions/${competitionId}/leaderboard`,
  },
  LEAGUES: {
    LIST: "/leagues",
    GET_BY_ID: (id: number) => `/leagues/${id}`,
    CREATE: "/leagues",
    UPDATE: (id: number) => `/leagues/${id}`,
    DELETE: (id: number) => `/leagues/${id}`,
    RANKING: (id: number) => `/leagues/${id}/Ranking`,
  },
  PUBLIC: {
    GET_COMPETITORS: "/PublicApi/competitors",
    STATISTICS: (competitorId: number) =>
      `/PublicApi/statistics/competitor/${competitorId}`,
    LEAGUES: "/PublicApi/leagues",
    COMPETITIONS: "/PublicApi/competitions",
    LEADERBOARD: (competitionId: number) =>
      `/PublicApi/competitions/${competitionId}/leaderboard`,
    GET_RANKING: (leagueId: number) => `/PublicApi/leagues/${leagueId}/ranking`,
  },
  // Altri endpoint futuri...
} as const;
